module.exports = __webpack_public_path__ + "img/Yipi_AnimacionWeb_11_Ipad.1d095213.gif";